import { render, staticRenderFns } from "./DiscoverySearchScene.vue?vue&type=template&id=a548aafe&scoped=true"
import script from "./DiscoverySearchScene.vue?vue&type=script&lang=js"
export * from "./DiscoverySearchScene.vue?vue&type=script&lang=js"
import style0 from "./DiscoverySearchScene.vue?vue&type=style&index=0&id=a548aafe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a548aafe",
  null
  
)

export default component.exports